import { UserRightsComments, UserRightsContacts, UserRightsTelephony, UserRightsOffers, UserRightsOrders, UserRightsProducts, UserRightsStatistics, UserRightsCalendars, UserRightsUsers, getAllRights as _getAllRights, UserRight } from "s2-rights";
import { Organization } from "../models/Organization";

export const customRights = {
  CallsGetEvents: "calls.getEvents" as UserRight,
}

export function listDefaultRights(): UserRight[] {
  return [UserRightsOrders.OrdersGetOwn]
};

export function getCustomRights(organization: Organization): UserRight[] {
  const rights: UserRight[] = [];
  if (!organization) {
    return rights;
  }

  if (organization.id === "65ae5275b0c00589992e000c") {
    //  IDentika
    //  Kan se händelser under pågående samtal.
    //  TODO: Ersätt detta med ett filter vilka händelser som visas.
    rights.push(customRights.CallsGetEvents);
  }

  return rights;
}

export function getAllRights(organization: Organization) {
  return [
    ..._getAllRights(),
    ...getCustomRights(organization)
  ];
}

export const orderRights = Object.values(UserRightsOrders);

//  Gör en logisk sortering (utan att behöva uppdatera s2-rights.)
orderRights.sort((a, b) => {
  const sorted = [
    UserRightsOrders.OrdersGetAll,
    UserRightsOrders.OrdersGetByOwnTeam,
    UserRightsOrders.OrdersGetOwn,
    UserRightsOrders.OrdersCreate,
    UserRightsOrders.OrdersUpdate,
    UserRightsOrders.OrdersBypassValidation,
    UserRightsOrders.OrdersDelete,
    UserRightsOrders.OrdersDeleteOwn,
    UserRightsOrders.OrdersGetFieldData,
    UserRightsOrders.OrdersGetUpdates,
  ];

  return sorted.indexOf(a) - sorted.indexOf(b);
});

export const commentRights = Object.values(UserRightsComments);

export const excludeListRights = Object.values(UserRightsContacts).filter(right =>
  right.startsWith('excludeList'));

export const contactRights = Object.values(UserRightsContacts)
  .filter(right => !excludeListRights.includes(right));

export const leadListRights = Object.values(UserRightsTelephony).filter(right =>
  right.startsWith('dialGroup') || right.startsWith('leadList'));

export const dialRights = Object.values(UserRightsTelephony)
  .filter(right => !leadListRights.includes(right));

export const offerTemplateRights = Object.values(UserRightsOffers)
  .filter(right => right.startsWith("offerTemplates."));

export const offerRights = Object.values(UserRightsOffers)
  .filter(right => !offerTemplateRights.includes(right));

export const productRights = Object.values(UserRightsProducts);

export const statisticsRights = Object.values(UserRightsStatistics);

export const userRights = Object.values(UserRightsUsers);

export const calendarRights = Object.values(UserRightsCalendars);
